import CGU from "../Exams/Register/Acknowledgment/CGU";

const CGUPage = () => {
  return (
    <div className="flex p-8 px-28 flex-col flex-start gap-8 self-stretch w-full h-full overflow-y-auto">
      <h1 className="text-2xl font-semibold">Conditions Générales d'Utilisation (CGU)</h1>
      <div className="flex flex-col gap-4 text-sm text-gray-700 leading-relaxed">
        <CGU />
      </div>
    </div>
  );
};

export default CGUPage;

